import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@redturtle/volto-io-studio/components';
import { dateTimeFormatter } from '@redturtle/volto-io-studio/helpers';
import { ConditionalLink } from '@plone/volto/components';
import { useIntl, defineMessages } from 'react-intl';

/* Style */
import './simpleCard.less';

const messages = defineMessages({
  seeMore: {
    id: 'seeMore',
    defaultMessage: 'Approfondisci',
  },
});

const SimpleCard = ({ item, isEditMode, showButton = true }) => {
  const intl = useIntl();

  return item ? (
    <div
      className="card-template"
      role="group"
      aria-label={showButton ? 'Card ' + item.title : null}
    >
      <div className="card-wrapper">
        {/* Data */}
        {item['@type'] !== 'Event' ? (
          <div className="date">
            {dateTimeFormatter(item?.effective ?? item?.created)}
          </div>
        ) : (
          <div className="date">
            {dateTimeFormatter(item?.start ?? item?.effective ?? item?.created)}
            <br />
            {item?.location && item.location}
          </div>
        )}

        {/* Titolo */}
        {showButton ? (
          <h3 className="title">{item.title}</h3>
        ) : (
          <ConditionalLink
            item={item}
            condition={!isEditMode}
            className={'title-link'}
          >
            <h3>{item.title ? item.title : item.id}</h3>
          </ConditionalLink>
        )}

        {/* Descrizione */}
        {item.description && <p>{item.description}</p>}

        {/* Read more button */}
        <div className="actions">
          {showButton && (
            <Button
              className="button"
              href={item.getURL}
              color="outline"
              aria-label={
                intl.formatMessage(messages.seeMore) + ' ' + item.title
              }
            >
              {intl.formatMessage(messages.seeMore)}
            </Button>
          )}

          {/* Tipologia di contenuto */}
          {/* {item?.type_title && <div className="topics">{item.type_title}</div>} */}

          {/* Categorie */}
          {item.Subject?.length > 0 && (
            <div className="topics">
              {item.Subject?.map((topic, i) => (
                <div key={item['@id'] + i}>
                  <span>{topic}</span>
                  {i + 1 !== item.Subject.length && ', '}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

SimpleCard.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SimpleCard;
